export enum BorrowersServiceErrors {
  PHONE_ALREADY_ACTIVE_FOR_ANOTHER_BORROWER = 'PHONE_ALREADY_ACTIVE_FOR_ANOTHER_BORROWER',
}
